import React from 'react';
import PropTypes from 'prop-types';

import Field from 'app/features/authentication/components/Field';
import noop from 'app/libs/noop';
import S from 'app/features/authentication/components/EmailField.styled';
import { EMAIL } from 'app/features/authentication/constants/inputNames';

const EmailField = ({
  floatingTextKey,
  errorTextKey,
  onEmailChange,
  validateEmail,
  testId,
}) => (
  <Field
    name={EMAIL}
    type={EMAIL}
    errorTextKey={errorTextKey}
    floatingTextKey={floatingTextKey}
    isValid={validateEmail}
    onValueChange={onEmailChange}
    as={S.EmailField}
    testId={testId}
  />
);

EmailField.propTypes = {
  floatingTextKey: PropTypes.string.isRequired,
  errorTextKey: PropTypes.string.isRequired,
  onEmailChange: PropTypes.func,
  validateEmail: PropTypes.func.isRequired,
  testId: PropTypes.string.isRequired,
};

EmailField.defaultProps = {
  onEmailChange: noop,
};

export default EmailField;
